var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessagesMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m1.14 11.829-.472-.167zm.91.911.167.472zm1.528-.54.166.472zm.515.05-.243.437zM1.66 9.74l.445-.228zm.04.498-.471-.167zM1.5 7A5.5 5.5 0 0 1 7 1.5v-1A6.5 6.5 0 0 0 .5 7zm.606 2.513A5.5 5.5 0 0 1 1.5 7h-1c0 1.07.259 2.08.717 2.97zm-.495 2.482.561-1.59-.942-.333-.562 1.59zm.273.274a.214.214 0 0 1-.273-.274l-.943-.333c-.34.963.587 1.89 1.55 1.55zm1.527-.54-1.527.54.333.943 1.527-.54zM7 12.5c-.968 0-1.876-.25-2.665-.687l-.485.874A6.5 6.5 0 0 0 7 13.5zM12.5 7A5.5 5.5 0 0 1 7 12.5v1A6.5 6.5 0 0 0 13.5 7zM7 1.5A5.5 5.5 0 0 1 12.5 7h1A6.5 6.5 0 0 0 7 .5zM3.744 12.672a.13.13 0 0 1 .106.015l.485-.874a1.13 1.13 0 0 0-.924-.084zM1.217 9.97c.022.043.02.08.013.102l.942.334a1.13 1.13 0 0 0-.066-.893z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 4.029,
  cy: 7.03,
  r: 0.75,
  fill: "currentColor"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.029,
  cy: 7.03,
  r: 0.75,
  fill: "currentColor"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.029,
  cy: 7.03,
  r: 0.75,
  fill: "currentColor"
})));
export { SvgMessagesMobile as ReactComponent };
export default __webpack_public_path__ + "static/media/messagesMobile.c96c0fc6ce7e6718c87d47c780ac1572.svg";